/** Sign-in, registration, and password-reset page copy. */
export const AUTH_COPY_DEFAULTS = {
  benefits: [
    'Faster checkout with saved details',
    'Track orders in your account',
    'Save addresses and reorder favorites',
  ],
  signin_aside_title: 'Welcome back',
  signin_checkout_aside_title: 'Sign in to complete your order',
  register_aside_title: 'Join Saloni Designs',
  register_checkout_aside_title: 'Create an account to checkout',
  signin_aside_text:
    'Sign in with your username or checkout email and password. Guest orders can be tracked without signing in.',
  register_aside_text:
    'Register with a username and password. Your email and phone help us deliver orders and send updates.',
  signin_checkout_subtitle: 'Sign in to continue to checkout. New here? Create an account below.',
  register_privacy_note:
    'Your details are used only for orders and delivery. We do not share them with third parties.',
  signin_new_prompt: 'New to Saloni Designs?',
  forgot_aside_title: 'Reset your password',
  forgot_aside_text:
    'We will email you a secure link to choose a new password. The link expires after one hour.',
  forgot_card_subtitle: 'Enter your account email and we will send a link to choose a new password.',
  forgot_whatsapp_prefill: 'Hi, I need help resetting my Saloni Designs account password.',
  reset_aside_title: 'Choose a new password',
  reset_aside_text: 'Use at least 8 characters. After saving, sign in with your new password.',
  reset_invalid_aside_title: 'Link expired or invalid',
  reset_invalid_aside_text: 'Password reset links expire after one hour. Request a new link to continue.',
  reset_invalid_body: 'This reset link is not valid. Please request a new one.',
};
